import React, { useState, useEffect } from 'react';
import { getWhatsAppLink } from '../config/site';
import { trackWhatsAppClick } from '../utils/analytics';
import './FloatingWhatsApp.css';

const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(true);
  const whatsappLink = getWhatsAppLink('Hello Dr. Muyabin, I would like to book an appointment.');

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      setIsVisible(documentHeight - (scrollTop + windowHeight) > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className={`floating-whatsapp ${isVisible ? 'visible' : ''}`}
      aria-label="Chat with us on WhatsApp"
      title="Chat with us on WhatsApp"
      onClick={() => trackWhatsAppClick('floating_button')}
    >
      <div className="whatsapp-icon">
        <svg viewBox="0 0 32 32" width="32" height="32">
          <path
            fill="currentColor"
            d="M16 0C7.164 0 0 7.164 0 16c0 2.828.744 5.488 2.044 7.792L0 32l8.624-1.956C10.824 31.36 13.324 32 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.008c-2.228 0-4.324-.58-6.152-1.592l-.44-.264-4.624 1.052 1.076-4.488-.292-.464A12.944 12.944 0 013.008 16c0-7.168 5.824-13 13-13s13 5.832 13 13-5.832 13-13 13zm7.108-9.824c-.404-.228-2.392-1.18-2.764-1.312-.372-.136-.644-.228-.916.228-.272.456-1.052 1.312-1.288 1.584-.236.272-.472.308-.876.076-.404-.228-1.704-.628-3.248-2.004-1.2-1.068-2.012-2.388-2.248-2.792-.236-.404-.024-.624.176-.824.18-.18.404-.472.608-.708.204-.236.272-.404.408-.676.136-.272.068-.512-.034-.708-.1-.196-.916-2.208-1.256-3.024-.332-.804-.672-.696-.916-.708-.236-.012-.512-.016-.784-.016s-.708.1-1.084.5c-.376.404-1.44 1.408-1.44 3.436 0 2.028 1.476 3.988 1.684 4.264.208.276 2.9 4.416 7.032 6.184.982.424 1.748.68 2.344.872.984.312 1.88.268 2.588.164.788-.112 2.424-.992 2.768-1.952.344-.96.344-1.784.24-1.952-.104-.172-.376-.272-.78-.5z"
          />
        </svg>
      </div>
      <span className="whatsapp-tooltip">Chat with us!</span>
    </a>
  );
};

export default FloatingWhatsApp;
